export default __webpack_public_path__ + "static/media/thermometer.3f163864.png";